import React, { Component, Fragment } from 'react';
import ReactTable from "react-table";
import PropTypes from "prop-types";
import {BeatLoader} from 'react-spinners';
import Modal from 'react-modal';
import { Link } from 'react-router-dom';
import NotificationSystem from 'react-notification-system';
import {get, postWithHeaders,postWithHeadersResponse, _delete} from "../../../server/actions";
import {_addNotification, _addNotificationError,getGradeIndexValue, isRegularLunchOrderType, 
    standardDateFormat,convertTwoDecimalPoint,getGradeIndex,isInt,getSchoolGrades, groupBy,setSchoolSessions} from '../../../server/util';
    const styles={
        customManageUsersStyles :{content: {
            top: '40%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            width: '30%',
            transform: 'translate(-50%, -50%)',
            overflow: 'initial'
        }}
          
    }
class LunchSessions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sessions: [],
            loading: false,
            grades:[],
            showModal:false,
            deleteRecId:0
        }
    }
    componentDidMount=()=>{
        const _grades= getSchoolGrades(undefined,false);
        this.setState({grades:_grades},()=>{
            this.getLunchSessions();
        });
        this._notificationSystem = this.refs.notificationSystem;
    }
    getLunchSessions(){
        this.setState({loading: true});
        const schoolId=sessionStorage.getItem('SchoolId');
        get(`/schoolSessions/search/findByMealSchoolId?mealSchoolId=${schoolId}&access_token=`).then((response) => {            
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            let list = (data._embedded.schoolSessions ||[]).slice();
            list.map(r=>{
                r.id=parseInt(r._links.self.href.split('/').pop());
            })
            setSchoolSessions(list);
            list.map(rec=>{
                (this.state.grades||[]).map(grade=>{
                    rec[grade.label]=rec.grades.includes(grade.value);
                })
            })
            this.setState({sessions:list,loading: false});            
        }).catch(
            (error) => {
                this.setState({sessions:[],loading: false});
                console.log('sessions get error', error);
            }
        );
    }
    deleteRecord=(recId)=>{
        this.setState({loading: true});
        _delete('/schoolSessions/'+recId+'/?access_token=')
            .then((response)=>{
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then((data)=>{
                _addNotification('Successfully deleted session data.', this);
                this.setState({loading: false, showModal:false, deleteRecId:0});
                this.getLunchSessions();
            }).catch(error=>{
                this.setState({loading: false, showModal:false, deleteRecId:0});
                _addNotificationError('Could not delete session data.', this);
            });
    }
    getColumns=()=>{
        const columns = [{
            Header: 'SESSION',
            accessor: 'session' // String-based value accessors!
          }];
          (this.state.grades||[]).map(grade=>{
              columns.push({
                  Header:grade.label,
                  accessor:grade.label,
                  style: { textAlign: 'center'},
                  Cell: ({ row }) =>{
                      return row._original[grade.label]?<i className="fa fa-check-square fa-2x"></i>:<i className="fa fa-square-o fa-2x"></i>
                    }
              })
          })
          columns.push({
              Header:'ACTION',
              style: { textAlign: 'center'},
              Cell:({ row }) =>{
                const schoolId=sessionStorage.getItem('SchoolId');
                const recId=parseInt(row._original._links.self.href.split('/').pop());
                let _assignedGrades=[];
                (this.state.sessions||[]).map(rec=>{
                   const rId= parseInt(rec._links.self.href.split('/').pop());
                    if(rId!==recId){
                        _assignedGrades=[..._assignedGrades, ...rec.grades]
                    }
                })

                return <Fragment><Link to={{
                    pathname: `/schoolAdmin/lunchSessionRecord/${recId}`,
                    state:{
                        schoolId,
                        rec:row._original,
                        assignedGrades:_assignedGrades,
                        sessionList:this.state.sessions
                    }
                }}><i className="fa fa-pencil-square fa-2x"></i></Link>
                <a href="javascript:void(0);" style={{paddingLeft:'5px'}} onClick={()=>{
                    this.setState({deleteRecId:recId,showModal:true});                    
                }}><i className="fa fa-trash-o fa-2x"></i></a>
                </Fragment>
              }
          })
          return columns
    }
    buildNewBtn=()=>{
        const schoolId=sessionStorage.getItem('SchoolId');
        let _assignedGrades=[];
        (this.state.sessions||[]).map(rec=>{
            _assignedGrades=[..._assignedGrades, ...rec.grades]
        })

        return <Link className="btn btn-success button-sm add-btn-sm"  to={{
            pathname: `/schoolAdmin/lunchSessionRecord/${0}`,
            state:{
                schoolId,
                rec:{},
                assignedGrades:_assignedGrades,
                sessionList:this.state.sessions
            }
        }}>New Session</Link>
    }
    render() {
        return (
            <Fragment>
                <NotificationSystem ref="notificationSystem"/>
                <section className=" full-width clearfix">
                    <div className='sweet-loading'
                         style={{position: 'fixed', top: '50%', left: '48%', zIndex: '1000'}}>
                        <BeatLoader
                            size={20}
                            color={'#ea7066'}
                            loading={this.state.loading}
                        />
                    </div>

                    <div className="container">
                        <div className="row">
                            <div className="sectionTitle">
                                <div className="col-md-2">
                                    <h2><span>Lunch Sessions</span></h2>
                                </div>
                                <div className="col-md-10 text-right">
                                    {
                                        this.buildNewBtn()
                                    }                                
                                </div>
                                
                            </div>
                        </div>
                        <div className="clearfix"></div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="panel panel-primary">
                                    <div className="panel-body">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <ReactTable
                                                    data={this.state.sessions}
                                                    columns={this.getColumns()}
                                                    defaultPageSize={10}
                                                    className="-striped -highlight"
                                                    noDataText='No data found'
                                                    sortable={true}
                                                    defaultSorting={[{
                                                        id: 'session',
                                                        desc: false
                                                        }]} minRows = {1} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <Modal isOpen={this.state.showModal}
                 onRequestClose={()=>{this.setState({showModal:false,deleteRecId:0})}}
                    style={styles.customManageUsersStyles}
                    contentLabel="Example Modal">
                     <div className="modal-header">
                        <h4 className="modal-title modal-title-color" id="deleteLabel">Delete session conformation</h4>
                        </div>
                        <div className="modal-body">
                            <p>Are you sure you want to delete session?</p>                            
                        </div>
                        <div className="text-right">
                            <button type="button" className="btn btn-primary btn-xs" style={{ margin: '0' }}
                                onClick={() => this.setState({ showModal: false,deleteRecId:0 })}><i
                                    className="glyphicon glyphicon-remove"
                                    style={{ marginRight: '0', paddingLeft: '0' }}></i> Cancel
                            </button>
                            <button type="button" className="btn btn-success btn-xs"
                                style={{ margin: '0 0 0 5px' }} onClick={()=>{
                                    this.deleteRecord(this.state.deleteRecId)
                                }}
                                id="deleteConfirm"><i className="glyphicon glyphicon-ok"></i> Ok
                            </button>
                    </div>
                </Modal>
            </Fragment>
        );
    }
}
LunchSessions.contextTypes = {
    router: PropTypes.object.isRequired
};

export default LunchSessions;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/LunchSessions/index.jsx